/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "rfbevjkopmvnodavkymu"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJmYmV2amtvcG12bm9kYXZreW11Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcxNzg1NTQsImV4cCI6MjA3Mjc1NDU1NH0.W8nLqTJ90zQgepfDCLgK8Hnq3eo_reVatqUuQV8gneg"